export const sessionsApi = {
  sessions: {
    queryKey: (params?: string[]) => ["sessions", ...(params || [])],
    route: () => `sessions`,
    methods: ["GET", "POST"],
  },
  session: {
    queryKey: (id: number, params?: string[]) => [
      "sessions",
      id,
      ...(params || []),
    ],
    route: (id: number) => `sessions/${id}`,
    methods: ["PATCH", "DELETE"],
  },
};
